import {setSliderCirclesAnimation} from './animations';

const TOP_SPACE = 400;

//const block = document.querySelector(`.slider-banner--single`);
const blocks = document.querySelectorAll(`.slider-banner--single`);
//let isInit = false;

const startAnimation = () => {
    /*if(!isInit && block.getBoundingClientRect().top <= TOP_SPACE) {
        setSliderCirclesAnimation(`.slider-banner--single`, 0);
        isInit = true;
    }*/

    for (let i = 0; i < blocks.length; i++) {
        let block = blocks[i];

        //if(!isInit && block.getBoundingClientRect().top <= TOP_SPACE) {
        if (block.getBoundingClientRect().top <= TOP_SPACE) {
            setSliderCirclesAnimation(`.slider-banner--single`, 0, i);
        }
    }

    //isInit = true;
};
startAnimation();
export const detectBlockOnScreen = () => window.addEventListener(`scroll`, startAnimation);
